import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaBars } from 'react-icons/fa';
import Icon from './Icon';

const HeaderContainer = styled.header`
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
`;

const Nav = styled.nav`
  max-width: 1200px;
  margin: 0 auto;  
  display: flex;
  justify-content: space-between;
  align-items: center;
  
`;

const Logo = styled(Link)<{ $scrolled?: boolean }>`
  img {
    height: ${({ $scrolled }) => ($scrolled ? '60px' : '100px')};
    margin-left: 3rem;
    transition: height 0.3s cubic-bezier(0.4,0,0.2,1), margin 0.3s cubic-bezier(0.4,0,0.2,1);
    @media (max-width: 768px) {
      height: ${({ $scrolled }) => ($scrolled ? '48px' : '80px')};
      margin-left: 1rem;
    }
  }
`;

const MenuToggle = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const NavMenu = styled.ul<{ $isOpen: boolean }>`
  display: flex;
  list-style: none;
  gap: 2rem;
  
  @media (max-width: 768px) {
    display: ${props => props.$isOpen ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    padding: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

const NavItem = styled.li`
  a {
    color: #333;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s;
    
    &:hover {
      color: #007bff;
    }
  }
`;

const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (sectionId: string) => {
    setIsMenuOpen(false);
    scrollToSection(sectionId);
  };

  return (
    <HeaderContainer>
      <Nav>
        <Logo to="/" $scrolled={scrolled}>
          <img src="/images/logo23.png" alt="Estima Pet Logo" />
        </Logo>
        <MenuToggle onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <Icon icon={FaBars} size={24} color="#333" />
        </MenuToggle>
        <NavMenu $isOpen={isMenuOpen}>
          <NavItem><a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('home'); }}>Home</a></NavItem>
          <NavItem><a href="#quem-somos" onClick={(e) => { e.preventDefault(); handleNavClick('quem-somos'); }}>Quem Somos</a></NavItem>
          <NavItem><a href="#servicos" onClick={(e) => { e.preventDefault(); handleNavClick('servicos'); }}>Serviços</a></NavItem>
          <NavItem><a href="#contato" onClick={(e) => { e.preventDefault(); handleNavClick('contato'); }}>Contato</a></NavItem>
        </NavMenu>
      </Nav>
    </HeaderContainer>
  );
};

export default Header; 